<template>
  <div>
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s1"></div>
        <div class="col s10 content-container">

          <TermAndCondition />

        </div>
        <div class="col s1"></div>
      </div>

    </div>

     <div>
      <SignUpFree v-if="!isAuth"/>
    </div>

  </div>
</template>

<script>

import loadingStore from '@/store/loading'
import SignUpFree from '@/components/SignUpFree.vue'
import TermAndCondition from '@/components/TermAndCondition.vue'
import useAuthStore from '@/store/authStore.js'

export default {
  name: 'PrivacyView', // Nome componente più specifico
  data () {
    return {
      useAuthStore: useAuthStore
    }
  },
  computed: {

    isAuth () {
      return this.useAuthStore.getters.isAuthenticated
    }
  },

  components: {
    SignUpFree,
    TermAndCondition
  },

  async mounted () {
    loadingStore.commit('setLoading', false)
  },

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style scoped>
/*
 * Ho usato <style scoped> per isolare questi stili al componente.
 * Se hai bisogno di stili globali (come per la griglia row/col), usa <style> non scoped.
 * Gli stili qui sotto sono locali e specifici per i contenuti della privacy.
 */

.content-container {
  padding: 20px;
  line-height: 1.6;
  color: #333;
  /* Testo leggibile */
}

</style>
